import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-6" }
const _hoisted_3 = { class: "col-xxl-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "col-lg-8" }
const _hoisted_12 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WelcomeBeautySalon = _resolveComponent("WelcomeBeautySalon")!
  const _component_CustomerSatisfactionRateChart = _resolveComponent("CustomerSatisfactionRateChart")!
  const _component_NewCustomers = _resolveComponent("NewCustomers")!
  const _component_TopSellingProducts = _resolveComponent("TopSellingProducts")!
  const _component_CustomersFromChannels = _resolveComponent("CustomersFromChannels")!
  const _component_FeaturedServices = _resolveComponent("FeaturedServices")!
  const _component_RecentAppointments = _resolveComponent("RecentAppointments")!
  const _component_RevenueByServicesChart = _resolveComponent("RevenueByServicesChart")!
  const _component_TopStylistPerformance = _resolveComponent("TopStylistPerformance")!
  const _component_TopCustomers = _resolveComponent("TopCustomers")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_WelcomeBeautySalon)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CustomerSatisfactionRateChart)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NewCustomers)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_TopSellingProducts)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_CustomersFromChannels)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_FeaturedServices)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_RecentAppointments)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_RevenueByServicesChart)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_TopStylistPerformance)
      ])
    ]),
    _createVNode(_component_TopCustomers)
  ], 64))
}